<template>
	<v-dialog v-model="mostrar" scrollable>
		<v-card>
			<!-- <v-toolbar flat :color="this.$store.state.title == 'calendario' ? this.$store.state.corEvento : cor"></v-toolbar> -->
			<v-toolbar flat :color="this.evento.color ? this.evento.color : this.$store.state.corEvento"></v-toolbar>
			<v-card-text>
				<v-row>
					<v-col cols="12" class="col-md-4">
						<v-text-field dense label="Título" outlined v-model="evento.titulo"></v-text-field>
					</v-col>
					<v-col cols="12" class="col-md-2">
						<v-select dense :items="this.itensLocais" v-model="evento.local" label="Local" outlined></v-select>
					</v-col>
					<v-col cols="12" class="col-md-2">
						<v-select dense :disabled="evento.reserva" :items="this.graus" v-model="evento.grau" label="Grau" outlined></v-select>
					</v-col>
					<v-col cols="12" class="col-md-2">
						<v-select dense :disabled="evento.reserva" :items="this.atividades" item-value="id_tipo" item-text="descricao"  v-model="evento.tipo" label="Atividade" outlined return-object></v-select>
					</v-col>
					<v-col cols="12" class="col-md-2">
						<v-checkbox dense label="Apenas reserva" v-model="evento.reserva"></v-checkbox>
					</v-col>
					<v-col cols="12" class="col-md-4">
						<v-menu ref="abrirDatePicker" v-model="abrirDatePicker" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field dense label="Data" v-model="dataFormatada" v-on="on" outlined></v-text-field>
							</template>
							<v-date-picker locale="pt-br" v-model="data" no-title @input="abrirDatePicker = false"></v-date-picker>
						</v-menu>
					</v-col>
					<v-col cols="12" class="col-md-4">
						<v-menu ref="abrirTimePickerIni" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field dense label="Inicio" v-model="horaInicio" v-on="on" outlined></v-text-field>
							</template>
							<v-time-picker format="24hr" v-model="horaInicio" @input="abrirTimePickerIni = false"></v-time-picker>
						</v-menu>
					</v-col>
					<v-col cols="12" class="col-md-4">
						<v-menu ref="abrirTimePickerFim" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
							<template v-slot:activator="{ on }">
								<v-text-field dense label="Fim" v-model="horaFim" v-on="on" outlined></v-text-field>
							</template>
							<v-time-picker format="24hr" v-model="horaFim" @input="abrirTimePickerFim = false"></v-time-picker>
						</v-menu>
					</v-col>
					
					<v-col cols="12" class="col-md-12">
						<v-textarea dense outlined label="Observações" v-model="evento.observacao"></v-textarea>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" :disabled="desativaSalvar()" text @click="salvarEvento()">Salvar</v-btn>
				<v-btn color="primary" text @click="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import { mapState } from 'vuex'
	import {baseApiUrl, showError, showSuccess} from '@/config/global'
	import axios from 'axios'
	//import Br from '@/config/barramento'

	export default{
        name: 'Evento',
        props: ['locais', 'atividades', 'evento', 'dia', 'mostrar'],
		computed:{
			...mapState(['timePickerOptionEvento', 'user']),
			itensLocais(){
				return this.locais.slice(1, this.locais.length)
			},
			modoAtual:{
				get(){
					return this.modo == 'edicao' ? 'edicao' : 'novo'
				},
				set(v){
					this.modo = v
				},
			},

			titulo(){
			   return this.modo == 'edicao' ? 'Editar Evento' : 'Novo Evento'
			},

			graus(){
				let arr = []
				for( let i = 1; i <= this.$store.state.user.outros.grauAtual; i++){
					arr[i-1] = {value: i.toString(), text: i.toString()}
				}
				
				return arr;
			},

			dt_evento(){
				let data = new Date(this.evento.objData_evento)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				return data
			},
        },
		data(){
			return{
				reserva: false,
				itemEvento: {},
				dialogExcluir: false,
				headers: [
					{text: 'Código', value: 'id_item', align: 'center', divider: true},
					{text: 'Nome', value: 'nome', align: 'center', divider: true},
					{text: 'Quantidade', value: 'quantidade', align: 'center', divider: true},
					{text: 'Qtd pendente', value: 'qtd_pendente', align: 'center', divider: true},
					{text: 'Und', value: 'nome_unidade', align: 'center', divider: true},
					{text: 'Ações', value: 'action', align: 'center', divider: true}
				],
				abrirDatePicker: false,
				abrirTimePickerIni: false,
				abrirTimePickerFim: false,
				itens: [],
				cadastrandoNovoItem: false,
				unidades:{},
				
				tiposEvento: {},
				showModal: false,
				showModalExcluir: false,
				modo: this.$route.params.modo,
				saved: false,
				concluido: false,
				data: '',
				dataFormatada: '',
				horaInicio: '',
				horaFim: '',
			}
		},
		methods:{

			desativaSalvar(){
				if(!this.evento.reserva){
					if(!this.evento.titulo || !this.evento.grau || !this.evento.local || !this.evento.tipo || !this.evento.objData_evento
					|| !this.evento.objInicio || !this.evento.objFim){
						return true
					}else{
						return false
					}
				}else{
					if(!this.evento.titulo || !this.evento.local || !this.evento.objData_evento
					|| !this.evento.objInicio || !this.evento.objFim){
						return true
					}else{
						return false
					}
				}
			},

			formataDateBr (dt) {
				if (!dt){
					return null
				} 
				const [year, month, day] = dt.split('-')
				const dataTxt = `${day}/${month}/${year}`
				return dataTxt
			},


			converterData(dt){
				let data = new Date(dt)
				let difHorario = data.getTimezoneOffset() / 60
				data = new Date(data.setHours(data.getHours() + difHorario))
				return data
			},

			converterHora(hr){
				
				 let data = new Date(this.evento.objData_evento).toISOString().substr(0,10)
				 const [year, month, day] = data.split('-')
				 data = new Date(year, month-1, day, hr.substr(0,2), hr.substr(3,2))

				 return data
			},

			salvarEvento(){
				
				if(!this.evento.reserva){
					this.evento.reserva = false
					if(this.evento.tipo.descricao){
						this.evento.tipo = this.evento.tipo.id_tipo
					}
				}
				
				if(this.evento.objFim <= this.evento.objInicio){
					showError("Horário inicio deve ser menor que horário fim")
					return false
				}

				this.itensLocais.forEach((v) => {
							if(this.evento.local == v.value){
								this.evento.local_nome = v.text
							}
						})

				if(!this.evento.id){
				
					const url = `${baseApiUrl}/eventos/insert.php`
					this.evento.iniciado = this.$store.state.user.iniciado
						
						axios.post(url, this.evento)
						.then(res => {
							
							if(res.data.codigo == '01'){
								showSuccess('Evento salvo com sucesso')
								if(!this.evento.reserva){
									const urlEmail = `${baseApiUrl}/emails/novoEvento.php`
						
									axios.post(urlEmail, this.evento)

									this.modoAtual = 'edicao'
									this.evento.id = res.data.evento
									this.saved = true
								}
								this.$emit('eventoCadastrado')
								this.fechar()
							}else{
								showError(res.data.mensagem)
								return false
							}
							
						})
	
				}else{
					const url = `${baseApiUrl}/eventos/update.php`
					
					if(this.evento.titulo && this.evento.objData_evento && this.evento.objInicio && this.evento.objFim  && this.evento.local){

						
						axios.post(url, this.evento)
						.then(res => {
							
							if(res.data.codigo == '01'){
								showSuccess('Evento salvo com sucesso')
								
								this.evento.dadosAnteriores = res.data.dadosAnteriores
								
								if(!this.evento.reserva){
									 const urlEmail = `${baseApiUrl}/emails/eventoAlterado.php`
									 axios.post(urlEmail, this.evento).then(res=>{
									 
									 })

									this.saved = true
								}
								this.$emit('eventoCadastrado')
								this.fechar()
								return true
							}else{

								showError(res.data.mensagem)
								return false
							}
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
						return false
					}	

				}
			},

			verMaterial(){
				this.showModal = true
				
				if(this.itens.length == 0){
					this.buscaItens()
				}
				
			},

			

			// salvarItem(){



			// 	if(!this.itemEvento.id_item){
					
			// 		if(this.itemEvento.unidade && this.itemEvento.nome && this.itemEvento.quantidade > 0){
			// 			const url = `${baseApiUrl}/itensEventos/inserir.php`
			// 			this.itemEvento.id_iniciado = this.user.iniciado
			// 			this.itemEvento.id_evento = this.evento.id
							
			// 			axios.post(url, this.itemEvento)
			// 			.then(res => {
							
			// 				if(res.data.codigo == '01'){
								
			// 					showSuccess(res.data.mensagem)
			// 					this.itemEvento.id_item = res.data.id_item
			// 					this.itemEvento.qtd_pendente = this.itemEvento.quantidade

			// 					this.unidades.forEach((v, i, a) => {
			// 						if(v.value == this.itemEvento.unidade){
			// 							this.itemEvento.nome_unidade = v.text
			// 						}
			// 					})
			// 					this.itens.push(this.itemEvento)
			// 					this.cadastrandoNovoItem = false	
								
			// 				}else{
								
			// 					showError(res.data.mensagem)
			// 				}
			// 			})
			// 		}else{
			// 			showError("Todos os campos devem ser informados")
			// 		}
					
			// 	}else{

			// 		const url = `${baseApiUrl}/itensEventos/update.php`
			// 		this.itemEvento.id_iniciado = this.user.iniciado

			// 		axios.post(url, this.itemEvento)
			// 		.then(res => {
						
			// 			if(res.data.codigo == '01'){
							
			// 				let idx = this.itens.findIndex((v, i, a) => {
                                
            //                     return v.id_item == this.itemEvento.id_item
            //                 })
							
			// 				this.itens[idx].quantidade = this.itemEvento.quantidade
                            
            //                 this.itemEvento.qtd_doacao >= 0 ? this.itens[idx].qtd_pendente = this.itemEvento.quantidade - this.itemEvento.qtd_doacao : this.itens[idx].qtd_pendente = this.itemEvento.quantidade
                            
                          

			// 				showSuccess(res.data.mensagem)
			// 				this.cadastrandoNovoItem = false	
							
			// 			}else{
							
			// 				showError(res.data.mensagem)
			// 			}
			// 		})

					
			// 	}
				
			// },

			// novoItem(){
			// 	this.itemEvento = {}
			// 	this.cadastrandoNovoItem = true
				
			// },

			// editarItem(item){
			// 	this.itemEvento = item
			// 	this.cadastrandoNovoItem = true
			// },

			// excluirItem(item){
				
			// 	//this.showModal = false
			// 	//this.showModalExcluir = true
			// 	this.dialogExcluir = true
			// 	this.itemEvento = item
			// },
			// confirmarExcluir(){
			// 	const url = `${baseApiUrl}/itensEventos/delete.php`
				
			// 	axios.post(url, {id: this.itemEvento.id_item})
			// 	.then(res => {
					
			// 		if(res.data.codigo == '01'){
						
			// 			showSuccess(res.data.mensagem)

			// 			let idx = this.itens.findIndex((v, i, a) => {
            //                     return v.id_item == this.itemEvento.id_item
            //                 })
						
			// 			this.itens.splice(idx, 1)
			// 			this.dialogExcluir = false

						
			// 		}else{
						
			// 			showError(res.data.mensagem)
			// 			this.dialogExcluir = false
			// 		}
			// 	})
		
			// },
			// cancelarExcluir(){
			// 	this.showModal = true
			// 	this.showModalExcluir = false	
			// },

			fechar(){
                this.cadastrandoNovoItem = false
				this.showModal = false
				//Br.setFecharEdicaoEvento('atualizado')
				this.$emit('fecharEvento')
            },


			// cancelarItem(){
			// 	if(this.itemEvento.id){
			// 		this.atualizaItemCancelado(this.itemEvento.id)
			// 	}else{
			// 		this.cadastrandoNovoItem = false
			// 	}
			// },

			// atualizaItemCancelado(id){
			// 	const url = `${baseApiUrl}/itensEventos/readOne.php?id_item=${id}`
				
			// 	axios.get(url)
			// 	.then(res => {
					
			// 		if(res.data.codigo == '01'){
						
			// 			let idx = this.itens.findIndex((v, i, a) => {
			// 				return v.id == res.data.dados[0].id
			// 			})

			// 			this.itens[idx] = res.data.dados[0]
						
			// 			this.cadastrandoNovoItem = false
						
			// 		}else{
			// 			showError(res.data.mensagem)
			// 		}
			// 	})
			// }
		},

		watch:{
			'evento.tipo'(v){
				
				this.$store.commit('setCorEvento', this.evento.tipo.cor)
				
			},
			data(){
				this.dataFormatada = this.formataDateBr(this.data)
				this.evento.objData_evento = this.converterData(this.data)
				
			},
			horaInicio(){
				this.evento.objInicio = this.converterHora(this.horaInicio)
			},
			horaFim(){
				this.evento.objFim = this.converterHora(this.horaFim)
			},
			evento(val){
				//this.evento.reserva = this.reserva 
				this.$store.commit('setNovoEvento', val)
			},

			mostrar(val){
				if(val){
					if(this.evento.id > 0){
						this.dataFormatada = this.formataDateBr(this.evento.objData_evento.toISOString().substr(0, 10))
						this.horaInicio = this.evento.inicio
						this.horaFim = this.evento.fim
						//this.reserva = this.evento.reserva
					}
				}
			}
		},

		created(){
			
		}
	}
</script>

<style scoped>
	
</style>